import { Component, Vue, PropSync } from 'vue-property-decorator';
import { FilterSidebarEventEnum } from '@/enums/FilterSidebarEventEnum';

@Component
export default class FilterSidebar extends Vue {
    @PropSync('share', { type: Boolean, default: true }) public syncedCanShare!: boolean;
    @PropSync('save', { type: Boolean, default: true }) public syncedCanSave!: boolean;
    @PropSync('remove', { type: Boolean, default: true }) public syncedCanRemove!: boolean;

    // tslint:disable-next-line: no-empty
    public mounted() {}

    public onClose(): void {
        this.$emit('sidebarEvent', FilterSidebarEventEnum.CLOSE);
    }

    public onApply(): void {
        this.$emit('sidebarEvent', FilterSidebarEventEnum.APPLY);
    }

    public onSave(): void {
        this.$emit('sidebarEvent', FilterSidebarEventEnum.SAVE);
    }

    public onReloadFilter(): void {
        this.$emit('sidebarEvent', FilterSidebarEventEnum.RELOAD_FILTER);
    }

    public onAdd(): void {
        this.$emit('sidebarEvent', FilterSidebarEventEnum.ADD);
    }

    public onRemove(): void {
        this.$emit('sidebarEvent', FilterSidebarEventEnum.REMOVE);
    }

    public onShare(): void {
        this.$emit('sidebarEvent', FilterSidebarEventEnum.SHARE);
    }
}
